<template>
  <div>
    <router-link :to="listRoutePath" tag="div" class="card border-primary" :class="{ pointer: listRoutePath !== '', 'border-danger': hasExceeded }">
      <div class="card-header p-3" :class="{ 'bg-danger': hasExceeded, 'text-white': hasExceeded }">
        <div class="widget-icon">
          <i class="no-pointer" :class="backgroundIcon" />
        </div>
        <div class="text-truncate">{{ title | capitalize }}</div>
      </div>

      <div class="card-body d-flex flex-column p-3" :class="{ 'text-danger': hasExceeded }">
        <h6 class="widget-value mb-3">{{ value }}</h6>
        <small v-if="max" class="widget-max">{{ maximumLabel | capitalize }}: {{ max }}</small>
        <small v-else class="widget-max" />
      </div>
    </router-link>

    <router-link v-if="addRoutePath !== ''"
                 :to="addRoutePath"
                 class="btn btn-block btn-flat btn-sm mt-2"
    >
      <small>{{ $t('home:add', { element: title }) }}</small>
    </router-link>
  </div>
</template>

<script>
import { upperFirst, camelCase } from 'lodash-es'

export default {
  props: {
    // Title of the widget, also used for "add" button
    title: {
      type: String,
      required: true
    },
    // Main value displayed in the widget
    value: {
      type: [Number, String],
      required: true
    },
    // Max value to display limit and progress bar
    max: {
      type: Number,
      default: null
    },
    // Route path for the click on the card
    listRoutePath: {
      type: String,
      default: ''
    },
    // Route path for the "add" button
    addRoutePath: {
      type: String,
      default: ''
    },
    // Background icon class
    backgroundIcon: {
      type: String,
      default: ''
    }
  },

  computed: {
    maximumLabel () {
      return this.$t('home:maximum' + upperFirst(camelCase(this.title)))
    },

    percentage () {
      if (this.value === '-') return 0
      if (this.max) return Math.min(this.value / this.max * 100, 100)
      else return 0
    },

    hasExceeded () {
      if (this.max && this.value > this.max) return true
      return false
    },

    color () {
      if (this.percentage >= 70) return 'danger'
      else if (this.percentage >= 30) return 'warning'
      else return 'success'
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .card-body {
    z-index: 10;
  }

  .widget-icon {
    float: right;
    padding: 0.75rem;
    margin-top: -2.5rem;
    background-color: $secondary;
    border-radius: 0.25rem;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 182, 25, 0.4);

    i {
      width: 30px;
      height: 30px;
      font-size: 30px;
      line-height: 30px;
      color: $white;
      text-align: center;
    }
  }

  .widget-value {
    font-size: 2rem;
    font-weight: 500;
    text-align: center;
  }

  .widget-max {
    height: 15px;
    text-align: center;
  }

  .widget-background {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    i {
      margin-top: 10px;
      font-size: 5rem;
      cursor: default;
      opacity: 0.05;
    }
  }
</style>
